import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {StreamConfigurationsService} from '../../../services/api/stream-configurations/stream-configurations.service';
import {
  deleteManyStreamConfigurations,
  deleteManyStreamConfigurationsFailure,
  deleteManyStreamConfigurationsSuccess
} from './stream-configuration.delete-many.actions';
import {StreamConfiguration} from '../../../services/api/stream-configurations/stream-configuration.model';
import {loadStreamConfigurations, manyStreamConfigurationsDeleted} from '../load-all/stream-configurations.load-all.actions';


@Injectable()
export class StreamConfigurationsDeleteManyEffects {

  // noinspection JSUnusedGlobalSymbols
  deleteManyStreamConfigurations$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyStreamConfigurations),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<StreamConfiguration>[] = ids
            .map((configurationId: UUID): Observable<StreamConfiguration> =>
              this.service.delete(configurationId)
            );

          return forkJoin(requests)
            .pipe(
              map(() => deleteManyStreamConfigurationsSuccess({ids})),
              catchError(error => of(deleteManyStreamConfigurationsFailure({error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyStreamConfigurationsSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyStreamConfigurationsSuccess),
        tap(() =>
          this.snackBar.open('Stream configurations successfully deleted', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) => manyStreamConfigurationsDeleted({ids: data.ids}))
      );
  });

  // noinspection JSUnusedGlobalSymbols
  deleteManyStreamConfigurationsFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(deleteManyStreamConfigurationsFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to delete stream configurations: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadStreamConfigurations())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: StreamConfigurationsService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
